"use strict";
exports.__esModule = true;
exports.createLogger = void 0;
var createLogger = function () {
    var logs = {
        deprecated: [],
        warning: [],
        error: []
    };
    var deprecated = function (field, oldValue) {
        logs.deprecated.push({ field: field, oldValue: oldValue });
    };
    var toConstValue = function (prismicValue, mapper) {
        if (!prismicValue) {
            return undefined;
        }
        var value = mapper[prismicValue];
        if (value === undefined) {
            logs.warning.push("La valeur \"" + prismicValue + "\" ne fait pas partie des valeurs possibles : " + Object.keys(mapper).join(', '));
        }
        return value;
    };
    var required = function (value) {
        if (value === null || value === undefined) {
            logs.error.push("La valeur \"" + value + "\" est manquante");
        }
        return value;
    };
    return {
        logger: { deprecated: deprecated, toConstValue: toConstValue, required: required },
        logs: logs.deprecated.length || logs.warning.length || logs.error.length
            ? logs
            : undefined
    };
};
exports.createLogger = createLogger;
//# sourceMappingURL=create-logger.js.map